
import { windVane } from "../../../utils/tmallGenius";
import { queryChannelListByLocation } from "../../../api";
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
components: { Search, Group, CellBox, Cell },
data() {
return {
keywords: "",
province: "",
city: "",
channelList: []
};
},
/*------------------------------------------- 开始运行 -------------------------------------------------------*/
created() {
this.getPCA(() => {
const params = {
province: this.province,
city: this.city,
support: 1, // 后台要求的，天猫精灵支持的频道
};
queryChannelListByLocation(params).then(res => {
const { status, message, data } = res;
if (status == 0) {
const list = [
{
name: "中央",
data: [],
type: 1
},
{
name: "卫视",
data: [],
type: 2
},
{
name: "地方",
data: [],
type: 3
}
];
data.map(item => {
list.map(ele => {
if (item.type == ele.type) {
ele.data.push(item);
}
});
});
this.channelList = list;
this.channelListBackup = list;
} else {
this.toast_fail();
}
});
});
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("频道选择");
next();
},
methods: {
/*------------------------------------------- 自定义方法-------------------------------------------*/
/* @name 更加经纬度获取省市区
*/
getPCA(cb) {
windVane
.getLocation()
.then(result => {
this.province = result.province.replace("省", "");
this.city = result.city.replace("市", "");
cb && cb();
})
.catch(e => {
alert("failure: " + JSON.stringify(e) + "请授权定位权限");
cb && cb();
});
},
onSearch(value) {
const keywordsReg = new RegExp(this.keywords.trim());
const channelListBackup = JSON.parse(JSON.stringify(this.channelListBackup));
let channelList = channelListBackup.map(item => {
const list = item.data.filter(ele => {
return keywordsReg.test(ele.channelName);
});
item.data = [...list];
return item;
});
console.log(channelList);
channelList = channelList.filter(item => item.data.length > 0);
this.channelList = channelList;
},
onCancel() {
const channelListBackup = JSON.parse(JSON.stringify(this.channelListBackup));
this.channelList = channelListBackup;
},
selectChannel(value) {
this.$router.replace({
path: "/settings/channel/add",
query: {
...this.$route.query,
channelName: value.channelName
}
});
}
/*------------------------------------------- 绑定方法 -------------------------------------------------------*/
}
};



// WEBPACK FOOTER //
// ./src/pages/settings/channel/ChannelSelect.vue